import { c as _c } from "react/compiler-runtime";
import { IcoWarning24 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
const ErrorComponent = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.entities.filters.drawer.playbooks"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mr-2"><IcoWarning24 color="error" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex">{t1}<p className="text-body-2 text-error fp-text">{t2}</p></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default ErrorComponent;
function _temp($) {
  return $.error;
}